'use client';

import React from 'react';
import { Tooltip, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { ILabelWithTooltipProps } from './LabelWithTooltip.types';

import './LabelWithTooltip.styles.scss';

const { Text } = Typography;

const LabelWithTooltip = ({ label, tooltip, fontSize, tooltipSize, align }: ILabelWithTooltipProps) => {
  const { t } = useTranslation();

  return (
    <div style={{ justifyContent: align }} className="np-label-with-tooltip">
      <Text style={{ fontSize }} className="np-label-with-tooltip__label">
        {t(label)}
      </Text>

      <Tooltip title={tooltip}>
        <QuestionCircleOutlined
          style={{ width: tooltipSize, height: tooltipSize }}
          className="np-label-with-tooltip__icon"
        />
      </Tooltip>
    </div>
  );
};

export default LabelWithTooltip;
